// Right-side drawer controller (Request Changes).

export function initDrawer() {
    $(document).on('click', '[data-bb-drawer-open]', function (e) {
        e.preventDefault();
        const id = $(this).attr('data-bb-drawer-open');
        $('#' + id).removeClass('bb-hidden');
    });

    $(document).on('click', '[data-bb-drawer-close]', function (e) {
        e.preventDefault();
        $(this).closest('[data-bb-drawer]').addClass('bb-hidden');
    });

    // Quick-option chips toggle
    $(document).on('click', '[data-bb-drawer] .bb-chip', function () {
        $(this).toggleClass('is-active');
    });

    $(document).on('click', '[data-bb-regenerate]', function (e) {
        e.preventDefault();
        const $button = $(this);
        const $drawer = $button.closest('[data-bb-drawer]');
        const url = String($drawer.attr('data-bb-regenerate-url') || '').trim();
        const draftId = String($drawer.attr('data-bb-draft-id') || $('[data-bb-preview]').attr('data-bb-draft-id') || '').trim();
        const feedback = drawerFeedback($drawer);

        if (isClickThroughMode()) {
            window.location.href = clickThroughUrl('/builder-promo/preview/update');
            return;
        }

        if (!url || !draftId) {
            drawerStatus($drawer, 'This preview is missing generation context. Start a new preview and try again.');
            return;
        }

        $button.prop('disabled', true).text('Regenerating...');
        drawerStatus($drawer, '');

        $.ajax({
            url,
            type: 'POST',
            data: {
                draft_id: draftId,
                feedback,
            },
            headers: ajaxHeaders(),
            success(response) {
                if (response && response.redirect) {
                    window.location.href = response.redirect;
                    return;
                }
                window.location.href = '/builder-promo/preview/update';
            },
            error(xhr) {
                drawerStatus($drawer, errorMessage(xhr, 'Could not regenerate this preview.'));
            },
            complete() {
                $button.prop('disabled', false).text('Regenerate');
            },
        });
    });

    $(document).on('click', '[data-bb-start-new-preview]', function (e) {
        e.preventDefault();
        $(this).closest('[data-bb-drawer]').addClass('bb-hidden');
        $('#bb-start-new-preview-modal').removeClass('bb-hidden');
        $('body').css('overflow', 'hidden');
    });

    $(document).on('click', '[data-bb-start-new-confirm]', function (e) {
        e.preventDefault();
        const $button = $(this);
        const $preview = $('[data-bb-preview]').first();
        const $drawer = $('[data-bb-drawer]').first();
        const draftId = String($drawer.attr('data-bb-draft-id') || $preview.attr('data-bb-draft-id') || '').trim();
        const deleteUrl = String($drawer.attr('data-bb-delete-run-url') || '').trim();
        const redirect = isClickThroughMode()
            ? clickThroughUrl('/builder-promo', { start_new_preview: '1' })
            : '/builder-promo?start_new_preview=1';

        if (isClickThroughMode()) {
            window.location.href = redirect;
            return;
        }

        if (!draftId || !deleteUrl) {
            window.location.href = redirect;
            return;
        }

        $button.prop('disabled', true).text('Starting...');
        $('[data-bb-start-new-status]').addClass('bb-hidden').text('');

        $.ajax({
            url: deleteUrl,
            type: 'POST',
            data: { draft_id: draftId },
            headers: ajaxHeaders(),
            success() {
                window.location.href = redirect;
            },
            error(xhr) {
                $('[data-bb-start-new-status]').removeClass('bb-hidden').text(errorMessage(xhr, 'Could not cancel this run.'));
            },
            complete() {
                $button.prop('disabled', false).text('Start New Preview');
            },
        });
    });
}

function drawerFeedback($drawer) {
    const quick = [];
    $drawer.find('[data-bb-quick-options] .bb-chip.is-active').each(function () {
        quick.push(String($(this).attr('data-value') || $(this).text() || '').trim());
    });

    const notes = String($drawer.find('[data-bb-change-notes]').val() || '').trim();
    const parts = [];
    if (quick.length) parts.push('Quick options: ' + quick.join(' '));
    if (notes) parts.push('Notes: ' + notes);

    return parts.join('\n\n');
}

function drawerStatus($drawer, message) {
    const $status = $drawer.find('[data-bb-drawer-status]');
    if (!message) {
        $status.addClass('bb-hidden').text('');
        return;
    }
    $status.removeClass('bb-hidden').text(message);
}

function isClickThroughMode() {
    try {
        return new URLSearchParams(window.location.search || '').get('clickthrough') === '1';
    } catch (e) {
        return false;
    }
}

function clickThroughUrl(path, params) {
    const url = new URL(path, window.location.origin);
    url.searchParams.set('clickthrough', '1');
    Object.keys(params || {}).forEach(function (key) {
        url.searchParams.set(key, params[key]);
    });
    return url.toString();
}

function ajaxHeaders() {
    return {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        Accept: 'application/json',
    };
}

function errorMessage(xhr, fallback) {
    if (xhr && xhr.responseJSON) {
        if (xhr.responseJSON.message) return xhr.responseJSON.message;
        if (xhr.responseJSON.error) return xhr.responseJSON.error;
    }
    return fallback;
}
